import { render, staticRenderFns } from "./rwZz.vue?vue&type=template&id=1def550d&scoped=true&"
import script from "./rwZz.vue?vue&type=script&lang=js&"
export * from "./rwZz.vue?vue&type=script&lang=js&"
import style0 from "./rwZz.vue?vue&type=style&index=0&id=1def550d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def550d",
  null
  
)

export default component.exports